module.exports = __webpack_public_path__ + "img/0xAd7F1844696652ddA7959a49063BfFccafafEfe7.f340cee4.png";